import axios from "axios";

export class OrderImagesDownloader {
    download(btn) {
        document.querySelector('#loading-overlay').style.display = 'block';

        const { url, econnabortedError } = btn.dataset;

        axios.get(url, {
            timeout: 60000,
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
        .then(apiResponse => {
            document.querySelector('#loading-overlay').style.display = 'none';
            if (apiResponse && apiResponse.data) {
                if (apiResponse.data.error) {
                    alert(apiResponse.data.error);
                } else {
                    apiResponse.data.forEach(function (file) {
                        let iFrame = document.createElement('iframe');
                        iFrame.hidden = true;
                        iFrame.setAttribute('src', '/splittedzips/download/' + file)
                        document.querySelector('body').append(iFrame);
                    });
                }
            }
        })
        .catch(error => {
            document.querySelector('#loading-overlay').style.display = 'none';

            if (error.code) {
                switch (error.code) {
                    case 'ECONNABORTED':
                        alert(econnabortedError);
                    break;
                }
            }
            else if (error.response && error.response.data && error.response.data.error) {
                alert(error.response.data.error);
            }
        });
    }
}
